import repository from "@/api/Seguridad.js";

export default {
  olvideContrasena(usuario) {
    let url = `olvide-contrasena/${usuario}`;
    return repository.post(url);
  }
};
